import { render, staticRenderFns } from "./Solicitud3.vue?vue&type=template&id=4a64f2fc&scoped=true&"
import script from "./Solicitud3.vue?vue&type=script&lang=js&"
export * from "./Solicitud3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a64f2fc",
  null
  
)

export default component.exports